<template>
  <main class="integral-main">
    <el-aside width="130px">
      <el-menu
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        :unique-opened="true"
        text-color="#757993"
        background-color="#fff"
        active-text-color="#409eff"
        router
      >
        <template v-for="item in sideItem">
          <el-menu-item :index="item.url" :key="item.url">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>
    <transition name="el-fade-in">
      <router-view></router-view>
    </transition>
  </main>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      sideItem: [
        {
          id: 0,
          name: "联盟审核",
          url:
            "/apply/newVip/13/market/marketing/client/integral/integral-audit"
        },
        {
          id: 1,
          name: "联盟列表",
          url: "/apply/newVip/13/market/marketing/client/integral/integral-list"
        },
        {
          id: 2,
          name: "联盟商品",
          url: "/apply/newVip/13/market/marketing/client/integral/point-goods"
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.integral-main {
  width: 100%;
  height: 100%;
  display: flex;
  > .integral-content {
    padding: 5px 10px;
  }
}
.el-menu-vertical-demo {
  height: 100%;
}
</style>
